var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.356C0 1.786 0.0886667 1.33 0.266 0.988C0.456 0.633333 0.709333 0.38 1.026 0.228C1.35533 0.076 1.71633 0 2.109 0C2.50167 0 2.85633 0.076 3.173 0.228C3.48967 0.38 3.743 0.633333 3.933 0.988C4.123 1.33 4.218 1.786 4.218 2.356C4.218 2.91333 4.123 3.36933 3.933 3.724C3.743 4.066 3.48967 4.31933 3.173 4.484C2.85633 4.636 2.50167 4.712 2.109 4.712C1.71633 4.712 1.35533 4.636 1.026 4.484C0.709333 4.31933 0.456 4.066 0.266 3.724C0.0886667 3.36933 0 2.91333 0 2.356Z",
    fill: "#D3D3D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPoint);
export default __webpack_public_path__ + "static/media/ListPoint.82efdf35cc83ff227bd301cd84b1966d.svg";
export { ForwardRef as ReactComponent };